import { all, takeEvery, takeLatest, put } from 'redux-saga/effects'
import { notification } from 'antd'
import { request } from '../../../../../admincore'

import { updateAccount } from '../../../api'
import actions from './actions'

// const getCompanySelect = state => state.companySelect

function* UPDATE({ payload: { params } }) {
  const companySelect = localStorage.getItem('app.settings.company')

  if (!companySelect || companySelect === -1) {
    return
  }
  yield put(request(updateAccount(companySelect, params), actions.UPDATE))
}

function* SUCCESS({ intl }) {
  yield notification.success({
    message: intl.formatMessage({ id: 'common.notifications.done' }),
    description: intl.formatMessage({ id: 'settings.account.notifications.updated' }),
  })
}

export default function* rootSaga() {
  yield all([takeEvery(actions.UPDATE, UPDATE), takeLatest(actions.UPDATE_SUCCESS, SUCCESS)])
}
